import { jsx as l } from "react/jsx-runtime";
const r = (o) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M32 19.002a6.513 6.513 0 0 1-6.506-6.505A6.512 6.512 0 0 1 32 5.99a6.512 6.512 0 0 1 6.506 6.506 6.513 6.513 0 0 1-6.506 6.505Zm0-10.01a3.51 3.51 0 0 0-3.506 3.505A3.51 3.51 0 0 0 32 16.002a3.51 3.51 0 0 0 3.506-3.505 3.51 3.51 0 0 0-3.506-3.506ZM33.884 55.172h-3.507a.29.29 0 0 1-.29-.29V44.63H25.62l3.144-13.05-.021-8.184 3.223-.854 3.225.855v8.049l3.185 13.184h-4.465v10.45l3-.803V47.63h5.276l-3.996-16.541v-10l-6.225-1.65-6.23 1.65.027 10.139-3.952 16.402h5.275v7.252a3.294 3.294 0 0 0 3.29 3.29h4.311l-.804-3Z"
      }
    )
  }
);
export {
  r as WomensToilet
};
